import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";
import { SearchIcon } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../core/components";

export const modalWidth = 720;

export const modalContainerStyle = css`
    margin: 0;
    padding: 0;
    border: none;
    box-shadow: none;
`;

export const listContainer = css`
    margin: 0 24px;
    border-top: none;
`;

export const headerStyle = css`
    padding: 0 24px 12px;
`;

export const newGroupWrapper = css`
    padding: 0 24px;
`;

export const searchInputStyle = css`
    width: 100%;
    margin-right: 11px;

    .sds-input-base .ant-input {
        padding-left: 38px;
    }
`;
export const SearchInputContainer = styled.div`
    position: relative;
    margin-bottom: ${Spacing.XS}px;
`;
export const SyledSearchIcon = styled(SearchIcon)`
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-55%);
`;
export const itemsModalStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;

    & .ant-modal {
        min-width: ${modalWidth}px;
    }
`;

export const ItemCard = styled(Flexbox)`
    cursor: pointer;

    margin-bottom: 8px;
    padding: 8px 25px 8px 8px;

    font-weight: 13px;
    color: ${Colors.Black.V50};

    border-radius: 5px;

    :hover {
        background-color: ${Colors.Gray.V50};
    }
`;

export const ItemName = styled.div`
    ${Fonts.Heading.H500};
    overflow: hidden;
    margin-right: 10px;
`;

export const scrollableContainer = css`
    overflow: auto;
    height: 50vh;
`;
